import { defineStore } from 'pinia';
import { IState } from './types';
import { state } from './state';
import { actions } from './actions';

export const useAuthStore = defineStore('auth', {
  state: (): IState => state,
  actions,
});
